import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UsersService } from './users.service';
import { NotificationService } from '../../shared/notification.service';
import { User } from '../../shared/user/user';
import { containsInsensitive } from '../../shared/utils/containsString';
import { Router } from '@angular/router';

@Component({
  selector: 'cc-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {
  @Input() msisdnId;
  public users: User[];
  public filteredUsers: User[];
  public selectAllUsersCheckbox = new FormControl(false);
  public selectedUsers = new FormControl([]);

  constructor(private usersService: UsersService, private router: Router, private notify: NotificationService) {}

  ngOnInit() {
    this.usersService.getUnassignedUsersForMsisdn(this.msisdnId).subscribe(unassignedUsers => {
      this.usersService.getAssignedUsersForMsisdn(this.msisdnId).subscribe(assignedUsers => {
        this.users = [...unassignedUsers, ...assignedUsers].sort((a, b) => a.name.localeCompare(b.name));
        this.filteredUsers = this.users;
        this.fillAssignedUsers(assignedUsers);
      });
    });
  }

  changeUsersForEvent(event) {
    this.changeUsers(event.source.value, event.checked);
  }

  private changeUsers(user, checked) {
    const selectedUsersValue = this.selectedUsers.value;
    let selectAllUserCheckboxValue = false;
    let updatedUsers = [...selectedUsersValue];

    if (checked) {
      updatedUsers = [...selectedUsersValue, user];
    } else {
      updatedUsers = selectedUsersValue.filter(item => item !== user);
    }

    this.selectedUsers.setValue(updatedUsers);

    if (updatedUsers.length) {
      selectAllUserCheckboxValue = this.users.length === updatedUsers.length ? true : null;
    }

    this.selectAllUsersCheckbox.setValue(selectAllUserCheckboxValue);
  }

  changeSelectAllState(isSelect) {
    if (isSelect !== null) {
      this.selectedUsers.setValue(isSelect ? this.users : []);
    }
  }

  isChecked(user) {
    return this.selectedUsers.value.filter(item => item === user).length;
  }

  fillAssignedUsers(users: User[]) {
    users.forEach(user => this.changeUsers(user, true));
  }

  goToInviteUser() {
    this.router.navigate(['users', 'all', 'invite', 'new']);
  }

  save() {
    const userIds = this.selectedUsers.value.map(user => user.id);
    this.usersService.assignUsersToMsisdn(this.msisdnId, userIds).subscribe(() => {
      this.notify.open('PHONE.USERS.SUCCESS');
    });
  }

  filterUsers(value) {
    this.filteredUsers = this.users.filter(
      user =>
        containsInsensitive(user.name, value) ||
        containsInsensitive(user.surname, value) ||
        containsInsensitive(user.username, value)
    );
  }
}
